export default __webpack_public_path__ + "static/038-2e16fc3160422a4d05ec448aa19c7b0a.png";